import { VideoOption } from '@openx/types/targeting/video.ts';
import { useVideoFormatOptionsFetch } from '@openx/utils/apiHooks/useVideoFormatFetch.ts';
import { useVideoLocationOptionsFetch } from '@openx/utils/apiHooks/useVideoLocationFetch.ts';
import { useVideoPlacementOptionsFetch } from '@openx/utils/apiHooks/useVideoPlacementFetch.ts';
import { extendOptionNameWithParentName } from '@openx/utils/lib/extendOptionNameWithParentName.ts';
import { useMemo } from 'react';

export function useVideoOptionsFetch(type: VideoOption, isUsed = true) {
  const format = useVideoFormatOptionsFetch({ enabled: isUsed && type === VideoOption.PRESENTATION_FORMAT });
  const location = useVideoLocationOptionsFetch({ enabled: isUsed && type === VideoOption.IN_STREAM_VIDEO_POSITION });
  const placement = useVideoPlacementOptionsFetch({ enabled: isUsed && type === VideoOption.PLACEMENT });

  return useMemo(
    () =>
      ({
        [VideoOption.PRESENTATION_FORMAT]: {
          isLoading: format.isVideoFormatLoading,
          options: format.videoFormats,
        },
        [VideoOption.IN_STREAM_VIDEO_POSITION]: {
          isLoading: location.isVideoLocationLoading,
          options: extendOptionNameWithParentName(location.videoLocations),
        },
        [VideoOption.PLACEMENT]: {
          isLoading: placement.isVideoPlacementLoading,
          options: placement.videoPlacement,
        },
      })[type] || {},
    [
      format.videoFormats,
      format.isVideoFormatLoading,
      location.videoLocations,
      location.isVideoLocationLoading,
      placement.videoPlacement,
      placement.isVideoPlacementLoading,
      type,
    ]
  );
}
